import React from 'react';
import { Divider } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import LinkIcon from '@mui/icons-material/Link';
import { AI_COLORS } from '../shared';

const materiais = [
  {
    categoria: 'Cartilhas e Guias',
    icone: <PictureAsPdfIcon style={{ color: AI_COLORS.blue400, fontSize: 32 }} />,
    itens: [
      {
        titulo: 'Guia de Higiene Bucal para Idosos — Ministério da Saúde',
        descricao: 'Orientações práticas sobre escovação, uso de fio dental e cuidados com próteses.',
        link: 'https://bvsms.saude.gov.br/bvs/publicacoes/saude_bucal.pdf',
      },
      {
        titulo: 'Caderno de Atenção Básica: Saúde Bucal',
        descricao: 'Documento do Ministério da Saúde com diretrizes de saúde bucal para todas as idades.',
        link: 'https://bvsms.saude.gov.br/bvs/publicacoes/caderno_atencao_basica_17_saude_bucal.pdf',
      },
    ],
  },
  {
    categoria: 'Vídeos Educativos',
    icone: <VideoLibraryIcon style={{ color: '#26C6DA', fontSize: 32 }} />,
    itens: [
      {
        titulo: 'Higiene bucal para idosos — Canal do CFO',
        descricao: 'Vídeo do Conselho Federal de Odontologia com orientações sobre higiene na terceira idade.',
        link: 'https://www.youtube.com/results?search_query=higiene+bucal+idosos',
      },
      {
        titulo: 'Como cuidar de próteses dentárias',
        descricao: 'Tutorial passo a passo para a higienização correta de próteses removíveis.',
        link: 'https://www.youtube.com/results?search_query=higienizacao+protese+dentaria',
      },
    ],
  },
  {
    categoria: 'Links Úteis',
    icone: <LinkIcon style={{ color: '#80cbc4', fontSize: 32 }} />,
    itens: [
      {
        titulo: 'Brasil Sorridente — Governo Federal',
        descricao: 'Informações sobre o programa nacional de saúde bucal e onde encontrar atendimento pelo SUS.',
        link: 'https://www.gov.br/saude/pt-br/assuntos/saude-de-a-a-z/s/saude-bucal',
      },
      {
        titulo: 'FOUFU — Faculdade de Odontologia da UFU',
        descricao: 'Informações sobre atendimento odontológico universitário em Uberlândia.',
        link: 'https://www.fo.ufu.br',
      },
      {
        titulo: 'Instituto Nacional do Câncer — Prevenção do Câncer Bucal',
        descricao: 'Orientações do INCA sobre fatores de risco e prevenção do câncer de boca.',
        link: 'https://www.inca.gov.br/tipos-de-cancer/cancer-de-boca',
      },
    ],
  },
];

export default function MateriaisEducativos() {
  return (
    <div style={{ paddingTop: 80, paddingBottom: 120, maxWidth: 900, margin: '0 auto', padding: '80px 24px 120px' }}>
      <h1 style={{ color: '#00838f', fontSize: '2rem', marginBottom: 8 }}>
        Materiais Educativos
      </h1>
      <p style={{ fontSize: '1.05rem', lineHeight: 1.7, marginBottom: 24, color: '#546e7a' }}>
        Recursos selecionados para aprofundar seu conhecimento sobre saúde bucal e geral para
        adultos e idosos. Todos os materiais são de fontes confiáveis e gratuitos.
      </p>
      <Divider style={{ marginBottom: 32 }} />

      {materiais.map((cat, i) => (
        <div key={i} style={{ marginBottom: 40 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
            {cat.icone}
            <h2 style={{ margin: 0, color: '#37474f' }}>{cat.categoria}</h2>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 16 }}>
            {cat.itens.map((item, j) => (
              <a
                key={j}
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none' }}
              >
                <div
                  style={{
                    background: j % 2 === 0 ? '#E1BEE7' : '#B2EBF2',
                    borderRadius: 12,
                    padding: '18px 20px',
                    height: '100%',
                    transition: 'transform 0.2s, box-shadow 0.2s',
                    cursor: 'pointer',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-3px)';
                    e.currentTarget.style.boxShadow = '0 6px 16px rgba(0,0,0,0.12)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  <h4 style={{ margin: '0 0 8px', color: '#37474f', lineHeight: 1.4 }}>
                    {item.titulo}
                  </h4>
                  <p style={{ margin: 0, fontSize: '0.9rem', color: '#546e7a', lineHeight: 1.5 }}>
                    {item.descricao}
                  </p>
                  <span style={{ fontSize: '0.8rem', color: '#26C6DA', marginTop: 8, display: 'block' }}>
                    Acessar →
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
